// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-overview-sub-section-sub-div {
  display: flex;
  align-items: center;
}

.campaign-overview-icons {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.campaigns-buttons-div {
  display: flex;
  font-size: 10px;
}

.campaign-overview-more-actions-div {
  width: 100%;
  align-items: center;
}

.campaign-overview-actions-sub-container {
  display: flex;
  gap: 0.8rem;
}

.campaigns-overview-drawer-div {
  padding-left: 35px;
  padding-top: 70px;
}
.copy-icon {
  font-size: 16px;
  color: #000;
  cursor: pointer;
  margin-left: 8px;
}

@media (max-width: 768px) {
  .mobile-add-to-cart {
    color: #fff !important;
    background: #d2042d !important;
    border: none !important;
    margin-left: 18px;
    width: max-content;
    border-radius: 5px;
  }
  .add-to-cart {
    margin-left: 0 !important;
    padding: 0.75rem;
  }
  .re-designed-campaign-verview-container {
    display: flex;
    flex-direction: column;
    gap: 10px !important;
  }
  .campaign-export-btn {
    width: 45% !important;
  }
  .add-to-cart {
    width: 45% !important;
    height: auto !important;
    display: flex;
    justify-content: center;
  }
  .re-designed-export-btn {
    background: var(--Icon-Default-Default, #ffffff) !important;
    border-top: 1px solid #d1d5dc !important;
    height: 38px !important;
    border-radius: 10px !important;
    border-width: 1px !important;
  }
  .re-export-button-size {
    width: 16px !important;
    height: auto !important;
  }
  .common-text-color-black-13 {
    font-size: 11px !important;
  }
  .redesigned-add-cart {
    height: 36px !important;
    border-radius: 10px !important;
    background: var(--Colors-Primary-500, #d2042d) !important;
  }
  .campaign-details-page-alignment-col {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/campaigns/CampaignOverview.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,2DAA2D;IAC3D,wCAAwC;IACxC,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,yDAAyD;EAC3D;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".campaign-overview-sub-section-sub-div {\n  display: flex;\n  align-items: center;\n}\n\n.campaign-overview-icons {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n\n.campaigns-buttons-div {\n  display: flex;\n  font-size: 10px;\n}\n\n.campaign-overview-more-actions-div {\n  width: 100%;\n  align-items: center;\n}\n\n.campaign-overview-actions-sub-container {\n  display: flex;\n  gap: 0.8rem;\n}\n\n.campaigns-overview-drawer-div {\n  padding-left: 35px;\n  padding-top: 70px;\n}\n.copy-icon {\n  font-size: 16px;\n  color: #000;\n  cursor: pointer;\n  margin-left: 8px;\n}\n\n@media (max-width: 768px) {\n  .mobile-add-to-cart {\n    color: #fff !important;\n    background: #d2042d !important;\n    border: none !important;\n    margin-left: 18px;\n    width: max-content;\n    border-radius: 5px;\n  }\n  .add-to-cart {\n    margin-left: 0 !important;\n    padding: 0.75rem;\n  }\n  .re-designed-campaign-verview-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px !important;\n  }\n  .campaign-export-btn {\n    width: 45% !important;\n  }\n  .add-to-cart {\n    width: 45% !important;\n    height: auto !important;\n    display: flex;\n    justify-content: center;\n  }\n  .re-designed-export-btn {\n    background: var(--Icon-Default-Default, #ffffff) !important;\n    border-top: 1px solid #d1d5dc !important;\n    height: 38px !important;\n    border-radius: 10px !important;\n    border-width: 1px !important;\n  }\n  .re-export-button-size {\n    width: 16px !important;\n    height: auto !important;\n  }\n  .common-text-color-black-13 {\n    font-size: 11px !important;\n  }\n  .redesigned-add-cart {\n    height: 36px !important;\n    border-radius: 10px !important;\n    background: var(--Colors-Primary-500, #d2042d) !important;\n  }\n  .campaign-details-page-alignment-col {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
